module.exports = __webpack_public_path__ + "static/img/manual_ja_1.c7c00ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_1.png
// module id = EDsw
// module chunks = 4